<template>
        <v-container
        class="scroll-y"
        fluid
        >
        <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>
  
        <v-row
        align="center"
        justify="center"
        >
        <v-col cols="10" md="10">
          <v-card class="ml-20 mr-20">
            <v-app-bar
            dark
            color="#2C3A47"
            >
            <v-btn icon>
              <v-icon>mdi-water</v-icon>
            </v-btn>
          <v-toolbar-title>Water Flow</v-toolbar-title>
          <v-spacer></v-spacer>
          
                <v-btn color="red" outlined @click="addNewItem">
                  <v-icon left>add</v-icon> ADD
                </v-btn>
            </v-app-bar>
            <v-container>
              <v-card class="mx-auto elevation-19">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  color="#2C3A47"
                  >
                  </v-text-field>
                </v-card-title>
        <v-data-table
        item-key="id"
        :headers="headers"
        :items="board"
        :search="search"
        
        >
        <template v-slot:[`item.updatedAt`]="{ item }">
      {{ formatDate(item.updatedAt) }}
    </template>
        <template v-slot:[`item.actions`]="{item}">
          <v-btn color="success" class="mx-2" fab x-small :to="{ name: 'Water Details', params: { id: item._id } }" outlined>
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn color="pink" fab x-small @click="deleteBoard(item._id)" outlined>
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template v-slot:no-results>
            <v-alert :value="true" color="pink" icon="warning" dark>
              Your Search {{search}} does not exist.
            </v-alert>
        </template>

        </v-data-table>
              </v-card>
            </v-container>
          </v-card>
          <v-snackbar
          v-model="snackbar"
          top
          right
          :color="color"
          >
          {{text}}
          <v-btn
          color="black"
          text
          @click="snackbar = false"
          >
          Dissmiss
          </v-btn>

          </v-snackbar>
        </v-col>

        </v-row>

        </v-container>
  
  
  
</template>
<script>
import router from "../../router";
import axios from "axios";
import moment from 'moment';

export default {
  data: () => ({
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: 'Water Flow',
          disabled: true,
          href: '',
        },
      ],
    mini: false,
    dialog:false,
    fab: false,
    search:'',
    snackbar: false,
    text:'',
    color:'',
    board:[],
    headers: [
        {text: 'Console Label', value: 'waterFlowConsole', sortable: true},
        {text: 'Console S/N', value: 'waterFlowSn.serialNumber', sortable: true},
        {text: 'Location', value: 'location.location', sortable: true},
        {text: 'Total Sensor', value: 'totalSensor', sortable: true},
        {text: 'Modified By', value: 'modifiedBy', sortable: true},
        {text: 'Last Modified Date', value: 'updatedAt', sortable: true},
        {text: 'Action', value: 'actions', sortable: false, width: '180px'},
    ],
 
  }),
  mounted() {
    this.loadsBoard();
  },
  methods: {
      addNewItem() {
      router.push("/water-board/add");
    },
    formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
  },
loadsBoard: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/water-board-all";
  axios.get(apiURL).then(res => {
    this.board = res.data;
  }).catch(error => {
    console.log(error)
  });
},
 deleteBoard(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to go back",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00b894",
        cancelButtonColor: "#d63031",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        // Send request to the server
        if (result.value) {
          try {
            let apiURL = process.env.VUE_APP_API + `/api/delete-water-board/${id}`;
            let indexOfArrayItem = this.board.findIndex(
              (i) => i._id === id
            );
            axios
              .delete(apiURL)
              .then(() => {
                this.board.splice(indexOfArrayItem, 1);
              })
              .catch((error) => {
                console.log(error);
              });
            this.$swal(
              "Deleted!",
              "Water Flow has been deleted.",
              "success"
            );
            //Notification error
            this.color = "error";
            this.text = "Water Flow has been deleted.";
            this.snackbar = true;
            //Notification error
          } catch (error) {
            this.$swal("Failed!", "There was something wrong.", "warning");
          }
        }
      });
    },
  },

}
</script>